export const grades = '/grades';
export const grade = (id: number) => `/grades/${id}`;
